<template>
  <div id="index" style="max-width:600px;margin:0 auto;">
    <v-layout>      
      <v-btn flat small color="primary" :to="{name: 'searchReviewDetail', params: {id: postId}}">
        <v-icon :size="30">keyboard_arrow_left</v-icon>カラログに戻る
      </v-btn>
      <v-spacer></v-spacer>
      <v-chip flat dark color="primary">カラログ編集</v-chip>
    </v-layout>
    <v-card style="min-height:600px;">
      <v-container>
        <div v-if="isLoading" style="text-align:center;margin-top:100px;">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        </div>
        <div v-else>
          <div style="margin-bottom:16px;">
            <p v-if="isFood">
              <food-card-min 
                :imageurl="foodImage" :name="postData.food.name"
              ></food-card-min>
            </p>
            <p v-else-if="isShop">
              <shop-card-min 
                :shop="postData.shop" 
              ></shop-card-min>
            </p>
            <p v-else-if="isShopGoogle">
              <shop-google-card-min 
                :shop="postData.shop" 
              ></shop-google-card-min>
            </p>
            <p>
              <v-btn v-if="isShop || isFood" @click="dialog=!dialog" block color="primary" outline round>食品・飲食店を選びなおす</v-btn>
              <v-btn v-else @click="dialog=!dialog" block color="primary" outline round><v-icon>add</v-icon>カラログした食品・飲食店を選択</v-btn>
            </p>
          </div>
          <review-form
            @onSendAccept='onSendAccept'
            @onSendFin='onSendFin'          
            @onMessage='onMessage'
            mode='edit'
            :postData='postData'
            :postId='postId'
            ref="myForm"
          ></review-form>
        </div>
      </v-container>
    </v-card>
    <!-- 食品・ショップ検索窓 -->
    <v-dialog v-model="dialog" persistent width="95%" max-width="700px">
      <v-card>
        <v-flex xs12 style="text-align:right">
          <v-btn icon @click="dialog = false"><v-icon>close</v-icon></v-btn>
        </v-flex>
        <object-search
          @onSelect='onSelect'
          mode="edit"
        ></object-search>
      </v-card>
    </v-dialog>
    <!-- ／食品・ショップ検索窓 -->
  </div>
</template>

<script>
import {db} from '../main'
import ReviewForm from '@/components/form/ReviewForm.vue'
import ObjectSearch from '@/components/card/ObjectSearch.vue'
import FoodCardMin from '@/components/card/FoodCardMin.vue'
import ShopCardMin from '@/components/card/ShopCardMin.vue'
import ShopGoogleCardMin from '@/components/card/ShopGoogleCardMin.vue'

import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  name: 'ReviewPostEdit',
  data () {
    return {
      postId: '',
      postData: {mode: ''},
      isLoading: false,
      dialog: false
    }
  },
  computed: {
    isFood () {
      if (this.postData.mode === 'food' || this.postData.mode === 'free') {
        return true
      } else {
        return false
      }
    },
    foodImage () {
      return getImageUrl.get('food_thumbs', this.postData.food.id, this.postData.food.imageurl)
    },
    isShop () {
      if (this.postData.mode === 'shop') {
        return true
      } else {
        return false
      }
    },
    isShopGoogle () {
      if (this.postData.mode === 'google') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.scrollIni()
    this.$store.commit('deleteTempFoodData')
    this.postId = this.$route.params.id
    this.getPostData()
  },
  methods: {
    async getPostData () {
      this.isLoading = true
      let response = await db.collection('post').doc(this.postId).get()
      this.postData = response.data()
      console.log(this.postData)
      this.isLoading = false
    },
    onFinSecound () {
      console.log('onFinSecound')
    },
    resetRank () {
      console.log('resetRank')
    },
    onSendAccept () {
    },
    onSendFin () {
      let obj = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you!!',
        text: 'カラログを更新しました。'
      }
      this.$emit('onMessage', obj)
      this.$store.commit('initPost')
      this.$router.push({name: 'searchReviewDetail', params: {id: this.postId}})
    },
    scrollIni () {
      window.scrollTo(0, 0)
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    },
    onSelect (type) {
      this.$refs.myForm.selectKaralogTarget(type)
      // 画面に選択したオブジェクト表示するための処理
      let f = this.$store.state.temp.foodData
      if (type === 'food') {
        let food= {}
        food = {
          id: f.id,
          name: f.name
        }
        if (f.images[0]) {
          food.imageurl = f.images[0]
        }
        this.postData.food = food
      } else if (type === 'shop' || type === 'google') {
        this.postData.shop = this.$store.state.temp.foodData
      }
      this.postData.mode = type
      this.dialog = false
    }
  },
  head: {
    title () {
      return {
        inner: 'カラログ編集',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミサイト「カライイネ」にカラログを投稿しよう'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  },
  components: {
    ReviewForm,
    ObjectSearch,
    FoodCardMin,
    ShopCardMin,
    ShopGoogleCardMin
  }
}
</script>

<style scoped>
  p {
    margin:0;
  }
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>